var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44922 11.8828C7.44922 11.5592 7.18688 11.2969 6.86328 11.2969H3.09766C2.77406 11.2969 2.51172 11.5592 2.51172 11.8828V17.6562H7.44922V11.8828Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.414 5.64844H15.6484C15.3248 5.64844 15.0625 5.91078 15.0625 6.23438V17.6562H19.414C19.6195 17.6562 19.8166 17.692 20 17.757V6.23438C20 5.91078 19.7376 5.64844 19.414 5.64844Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 0.585938C13.7226 0.262344 13.4603 0 13.1367 0H9.37109C9.0475 0 8.78516 0.262344 8.78516 0.585938V17.6562H13.7226V0.585938Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 18.8281H1.17188V0.585938C1.17188 0.262344 0.909531 0 0.585938 0C0.262344 0 0 0.262344 0 0.585938V19.4141C0 19.7377 0.262344 20 0.585938 20H19.4141C19.7377 20 20 19.7377 20 19.4141C20 19.0905 19.7377 18.8281 19.4141 18.8281Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiring);
export default __webpack_public_path__ + "static/media/wiring.8ea0a1c16f7a71b28f1f989f64c79497.svg";
export { ForwardRef as ReactComponent };